import { render, staticRenderFns } from "./OfferStatusForm.vue?vue&type=template&id=1474fbbc&scoped=true"
import script from "./OfferStatusForm.vue?vue&type=script&lang=js"
export * from "./OfferStatusForm.vue?vue&type=script&lang=js"
import style0 from "./OfferStatusForm.vue?vue&type=style&index=0&id=1474fbbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1474fbbc",
  null
  
)

export default component.exports